import AddUnitAttachmentToAdvertisingHtml from '../units/unit.attachment.add-to-advertising.html';
import VehicleAttachmentsHtml             from './vehicle.attachments.html';

export function VehicleAttachmentsDirective (
  $http,
  $state,
  $translate,
  $uibModal,
  $window,
  API,
  attachmentsApi,
  confirm,
  messages,
  workshopAPI
) {
  return {
    restrict: 'E',
    scope   : {
      attachments: '=',
      options    : '=',
      unit       : '='
    },
    templateUrl: VehicleAttachmentsHtml,
    link (scope, element) {
      scope.orderingMode = false;
      scope.thumbnails   = {
        isLoading    : true,
        isSuccessful : false,
        percentLoaded: 0
      };

      for (var i=0; i<scope.attachments.length; i++) {
        scope.attachments[i].ordering = i + 1;
      }

      scope.addToAdvertising = function (attachment) {
        $uibModal.open({
          controller : 'AddUnitAttachmentToAdvertisingCtrl',
          templateUrl: AddUnitAttachmentToAdvertisingHtml,
          windowClass: 'lg-modal',
          resolve    : {
            advertising        : () => workshopAPI.get('/dealership_advertising_setting'),
            attachment         : () => attachment,
            vehicle_advertising: () => workshopAPI.get('/dealership_advertising_vehicles/for_vehicle/', attachment.vehicle_id)
          }
        });
      };

      scope.delete = function (attachment) {
        if (scope.orderingMode) {
          messages.error($translate.instant('DEALERSHIP_SPACE.CANNOT_DELETE_ATTACHMENTS'));

          return ;
        }

        attachmentsApi.deleteAttachment(attachment, scope.options)
        .then(() => {
          messages.show($translate.instant('JS_SPACE.MESSAGES.DELETED.DELETED'), 'success');

          $state.reload();
        })
        .catch(err => {
          messages.error(err);
        });
      };

      scope.download = function (attachment) {
        if (window.navigator.msSaveBlob) {
          $http.get(attachment.attachment_url).then(function (data) {
            window.navigator.msSaveBlob(data.data, 'attachment');
          });
        }
        else {
          $window.open(attachment.attachment_url, '_blank' );
        }
      };

      scope.emailVideo = function ( attachment ) {
        attachmentsApi.sendVideo(attachment, {
          contact: scope.options.contact,
          method : 'email',
          table  : scope.options.table
        })
        .then(() => {
          messages.show($translate.instant('JS_SPACE.MESSAGES.EMAIL_SENT'), 'success');
        });
      };

      scope.getElement = function () {
        return element.find('input[type="file"]')[0];
      };

      scope.isFileAttached = function () {
        const files = scope.getElement().files;

        return !!files.length;
      };

      scope.isPdf = function (attachment) {
        return attachmentsApi.isPdf(attachment);
      };

      scope.isVideo = function (attachment) {
        return attachmentsApi.isVideo(attachment);
      };

      scope.moveDown = function (attachment) {
        if (attachment.ordering < scope.attachments.length) {
          scope.attachments.filter(object => object.ordering === attachment.ordering + 1)[0].ordering -= 1;

          attachment.ordering += 1;
          scope.saveOrdering();
        }
      };

      scope.moveUp = function (attachment) {
        if (attachment.ordering > 1) {
          scope.attachments.filter(object => object.ordering === attachment.ordering - 1)[0].ordering += 1;

          attachment.ordering -= 1;
          scope.saveOrdering();
        }
      };

      scope.saveAttachments = function () {
        return workshopAPI.patch('/vehicle_attachments', { vehicle_attachments: scope.attachments }, 'vehicle_attachments_batch');
      };

      scope.saveOrdering = function () {
        var attachments = {
          vehicle_attachments: []
        };

        attachments.vehicle_attachments = scope.attachments.map(attachment => {
          return {
            id         : attachment.id,
            description: attachment.description,
            ordering   : attachment.ordering
          };
        });

        workshopAPI.patch('/vehicle_attachments', attachments, 'vehicle_attachments_batch')
        .catch(err => {
          messages.show(err);
        });
      };

      scope.selectAttachmentForOrdering = function (selectedAttachment) {
        if (scope.orderingMode) {
          angular.forEach(scope.attachments, attachment => {
            attachment.selected = false;
          });

          selectedAttachment.selected = true;
        }
      };

      scope.showAttachment = function (attachment) {
        if (!scope.orderingMode) {
          attachmentsApi.showAttachment(attachment);
        }
      };

      scope.smsVideo = function ( attachment ) {
        attachmentsApi.sendVideo(attachment, {
          contact: scope.options.contact,
          method : 'sms',
          table  : scope.options.table
        })
        .then(() => {
          messages.show($translate.instant('GENERAL_SPACE.MESSAGE.SMS_SENT'), 'success');
        });
      };

      scope.toggleEditMode = function (attachment) {
        attachment.editMode = !attachment.editMode;

        if (!attachment.editMode) {
          scope.saveAttachments()
          .catch(err => {
            messages.error(err);
          });
        }
      };

      scope.upload = function () {
        scope.uploading = true;

        attachmentsApi.upload(scope.file, scope.options)
        .then(attachments => {
          scope.file               = null;
          scope.getElement().value = null;

          scope.$broadcast('hide');

          /**
           * Set the attachments varable to the new list from the server.
           * Must be done this way so that the array doesn't lose it's reference
           * because the scope variable is technically initialized in the parent
           * scope.
           */
          scope.attachments.length = 0;
          Array.prototype.push.apply(scope.attachments, attachments);

          return attachmentsApi.getThumbnails(scope.thumbnails, attachments);
        })
        .catch(err => {
          messages.error(err);
        })
        .finally(() => {
          scope.uploading = false;

          scope.$broadcast('show');
        });
      };

      attachmentsApi.getThumbnails(scope.thumbnails, scope.attachments);
    }
  };
}